import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED,
  PATIENT_LIST_RECEIVED,
  PATIENT_NOTE_RECEIVED,
  PENDING_PATIENT_RECEIVED,
  SELECTED_PATIENT_NAME_ADDED,
} from "../constants/types/patientType";
import axios from "../utils/axios";
import { appLoading } from "./alertAction";

export const setSelctedPatientFromPatinetList = (name) => (dispatch) => {
  dispatch({
    type: SELECTED_PATIENT_NAME_ADDED,
    payload: name,
  });
};
export const practitionerSavePatient = (data, callback) => (dispatch) => {
  axios.get(`practitionerPatientConnect?${data}`).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const patientNotesGetAction =
  (action, patientId = "", noteId = "", note = "", callback) =>
  (dispatch) => {
    axios
      .get(
        `practitionerPatientNotes?action=${action}&ppc_id=${patientId}&ppn_id=${noteId}&notes=${note}&title=`
      )
      .then(
        (resp) => {
          if (resp.data.message) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
          } else if (resp.data.error) {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          } else {
            dispatch({
              type: PATIENT_NOTE_RECEIVED,
              payload: resp.data.length > 0 ? resp.data : [],
            });
          }
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const getSoapNote = (patientId, callback) => (dispatch) => {
  axios
    .get(`practitionerPatientNotes?action=getSoapNotes&ppc_id=${patientId}`)
    .then(
      (resp) => {
        if (resp.data.notes) {
          callback(resp.data.notes);
        } else if (resp.data.error) {
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
          callback && callback();
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        callback && callback();
      }
    );
};

export const addSoapNotes =
  (action, patientId = "", noteId = "", note = "", callback) =>
  (dispatch) => {
    axios
      .get(
        `practitionerPatientNotes?action=${action}&ppc_id=${patientId}&note=${note}&note_id=${noteId}`
      )
      .then(
        (resp) => {
          if (resp.data.message) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
          } else if (resp.data.error) {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          } else {
            dispatch({
              type: PATIENT_NOTE_RECEIVED,
              payload: resp.data.length > 0 ? resp.data : [],
            });
          }
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const getPendingRequests = () => (dispatch) => {
  axios.get("practitionerPatientConnect?action=getPatientsPending").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: PENDING_PATIENT_RECEIVED,
          payload: resp.data.patientList,
        });
      } else {
        dispatch({
          type: PENDING_PATIENT_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getPatients = (callback) => (dispatch) => {
  axios.get("practitionerPatientConnect?action=getPatients").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: PATIENT_LIST_RECEIVED,
          payload: resp.data.patientList,
        });
      } else {
        dispatch({
          type: PATIENT_LIST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getCreatePrescriptionPatients = (callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios
    .get("practitionerPatientConnect?action=getCreatePrescriptionPatients")
    .then(
      (resp) => {
        if (resp.data?.result == "success") {
          dispatch({
            type: CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED,
            payload: resp.data.patientList,
          });
          callback && callback(resp.data.patientList);
        } else {
          dispatch({
            type: CREATE_PRESCRIPTION_PATIENT_LIST_RECEIVED,
            payload: [],
          });
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
          callback && callback();
        }
        dispatch(appLoading(false));
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        callback && callback();
        dispatch(appLoading(false));
      }
    );
};

export const acceptOrRejectPatient =
  (actionName, Id, callback) => (dispatch) => {
    axios
      .get(`practitionerPatientConnect?action=${actionName}&ppc_id=${Id}`)
      .then(
        (resp) => {
          if (resp.data) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
            callback && callback();
          } else {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      );
  };

export const patientPostAction = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("practitionerPatientConnect", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback(resp.data?.patient_id);
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      dispatch(appLoading(false));
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      dispatch(appLoading(false));
    }
  );
};
